import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/edit/')({
  beforeLoad: () => {
    throw redirect({
      to: '/edit/$resumeId',
      params: { resumeId: 'example' },
      search: { editor: undefined },
    });
  },
});
